var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floating-label-wrap",class:_vm.wrapperClass},[_vm._t("input"),(_vm.label)?_c('label',{staticClass:"floating-label mb-0",class:_vm.labelClasses},[_c('span',[_vm._v(_vm._s(_vm.label))])]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }